"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var swr_hooks_1 = require("@l2p/swr-hooks");
var ACTIVE_ITEM_HEIGHT = 50;
var BORDER_ITEM = 1;
var WheelPicker = function (_a) {
    var handleOnChange = _a.handleOnChange, options = _a.options, value = _a.value, closeDropdown = _a.closeDropdown;
    var translateLocale = (0, swr_hooks_1.useLocaleTranslations)();
    var _b = (0, react_1.useState)(function () {
        var initialIdx = options.findIndex(function (item) { return item.title === value; });
        return initialIdx !== -1 ? initialIdx : 0;
    }), selectedIndex = _b[0], setSelectedIndex = _b[1];
    var startY = (0, react_1.useRef)(0);
    var wheelRef = (0, react_1.useRef)(null);
    var updateSelection = function (newIndex) {
        var indexToUpdate = newIndex;
        if (newIndex < 0)
            indexToUpdate = 0;
        else if (newIndex >= options.length)
            indexToUpdate = options.length - 1;
        handleOnChange(options[indexToUpdate].id);
        setSelectedIndex(indexToUpdate);
    };
    var handleTouchStart = function (e) {
        startY.current = e.touches[0].clientY;
    };
    var handleTouchMove = function (e) {
        var deltaY = e.touches[0].clientY - startY.current;
        if (deltaY > 30) {
            updateSelection(selectedIndex - 1);
            startY.current = e.touches[0].clientY;
        }
        else if (deltaY < -30) {
            updateSelection(selectedIndex + 1);
            startY.current = e.touches[0].clientY;
        }
    };
    (0, react_1.useEffect)(function () {
        var touchmoveHandler = function (e) { return e.preventDefault(); };
        document.addEventListener('touchmove', touchmoveHandler, { passive: false });
        return function () {
            document.removeEventListener('touchmove', touchmoveHandler);
        };
    }, []);
    var calculateScaleFactorHeight = (0, react_1.useCallback)(function (distanceFromCenter) { return Math.max(1 - 0.3 * distanceFromCenter, 0.1); }, []);
    var calculateScaleFactorTransform = (0, react_1.useCallback)(function (distanceFromCenter) { return Math.max(1 - 0.2 * distanceFromCenter, 0.1); }, []);
    var calculateItemHeightOffsetCenter = (0, react_1.useCallback)(function (idxToCompare) {
        var distanceFromCenter = Math.abs(idxToCompare);
        var scaleFactorHeight = calculateScaleFactorHeight(distanceFromCenter);
        return ACTIVE_ITEM_HEIGHT * scaleFactorHeight;
    }, [calculateScaleFactorHeight]);
    (0, react_1.useEffect)(function () {
        var wheelElement = wheelRef.current;
        if (wheelElement) {
            var secondItemHeight = calculateItemHeightOffsetCenter(1);
            var thirdItemHeight = calculateItemHeightOffsetCenter(2);
            var offset = void 0;
            if (selectedIndex === 0)
                offset = ACTIVE_ITEM_HEIGHT;
            else if (selectedIndex === 1)
                offset = ACTIVE_ITEM_HEIGHT - secondItemHeight;
            else {
                offset =
                    ACTIVE_ITEM_HEIGHT -
                        secondItemHeight -
                        (selectedIndex - 1) * (thirdItemHeight + BORDER_ITEM * 2);
            }
            wheelElement.style.transform = "translateY(".concat(offset, "px)");
        }
    }, [selectedIndex, calculateItemHeightOffsetCenter]);
    return (react_1.default.createElement("ul", { ref: wheelRef, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, className: styles_module_scss_1.default.wheel }, options.map(function (o, idx) {
        var distanceFromCenter = Math.abs(selectedIndex - idx);
        var scaleFactorHeight = calculateScaleFactorHeight(distanceFromCenter);
        var scaleFactorTransform = calculateScaleFactorTransform(distanceFromCenter);
        var height = ACTIVE_ITEM_HEIGHT * scaleFactorHeight;
        return (react_1.default.createElement("li", { key: o.id, className: "".concat(styles_module_scss_1.default.item, " ").concat(selectedIndex === idx ? styles_module_scss_1.default.selected : ''), onClick: function () {
                if (selectedIndex === idx)
                    closeDropdown();
            }, style: {
                height: "".concat(height, "px"),
                opacity: scaleFactorTransform,
                transform: "scale(".concat(scaleFactorTransform, ")"),
            } }, translateLocale(o.title)));
    })));
};
exports.default = WheelPicker;
